import { render, staticRenderFns } from "./IndemnityModalStepAddNosologicTemplate.vue?vue&type=template&id=24ca49de&scoped=true"
import script from "./IndemnityModalStepAddNosologicTemplate.vue?vue&type=script&lang=js"
export * from "./IndemnityModalStepAddNosologicTemplate.vue?vue&type=script&lang=js"
import style0 from "./IndemnityModalStepAddNosologicTemplate.vue?vue&type=style&index=0&id=24ca49de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ca49de",
  null
  
)

export default component.exports